import styled, { css, keyframes } from 'styled-components';
import { BREAKPOINTS, COLORS } from '../../styles';
import { NavLink } from 'react-router-dom';

export const RowLayout = styled.div`
  display: flex;
  align-items: center;
`;

export const Button = styled.button`
  background-color: ${COLORS.white};
  font-weight: bold;
  border: 0;
`;

const flowLeft = keyframes`
  0% {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const flowRight = keyframes`
  0% {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(100%);
  }
`;

export const Menu = styled.ul`
  height: 100%;
  list-style: none;
  margin: 0 auto 0 auto;
  background-color: ${COLORS.white};
  box-sizing: border-box;
  display: none;
  right: 0;
  top: 0;
  min-width: 300px;
  position: absolute;
  z-index: 100;
  align-items: center;
  width: 320px;
  padding-inline-start: 0;

  ${BREAKPOINTS.SMALL} {
    min-width: 360px;
  }

  .open & {
    display: block;
    -webkit-animation: ${flowLeft} 0.3s ease-in-out;
    animation: ${flowLeft} 0.3s ease-in-out;
  }

  .closed & {
    display: block;
    -webkit-animation: ${flowRight} 0.3s ease-in-out;
    animation: ${flowRight} 0.3s ease-in-out;
  }
`;

export const Right = styled.div`
  display: flex;
  margin-left: auto;
`;

export const SiteName = styled.span`
  color: ${COLORS.neutral_600};
  font-weight: bold;
  font-size: 14px;
  margin-left: 4px;
`;

export const MenuSection = styled.li`
  margin-top: 16px;
  .disabled-link {
    color: #21212150;
    pointer-events: none;
    key-events: none;
  }
`;

export const MenuSectionList = styled.ul`
  list-style: none;
  padding: 0;

  li {
    width: 80%;
    height: 48px;
    margin: 0 auto 0 12px;
    line-height: 48px;
  }
`;

export const UserMenuSectionListStyling = css`
  li:hover:not(.disabled) {
    background-color: ${COLORS.primary_20};
    a {
      color: ${COLORS.primary_600};
    }
    svg {
      color: ${COLORS.primary_600};
    }
  }

  li:focus-within:not(.disabled) {
    box-shadow: 0px 0px 8px ${COLORS.primary_500}, 0px 4px 12px rgba(46, 127, 161, 0.25);
    a {
      outline: none;
    }
  }

  li:active:not(.disabled) {
    background: ${COLORS.primary_100};
    box-shadow: none;
    a {
      color: ${COLORS.primary_800};
    }
    svg {
      color: ${COLORS.primary_800};
    }
  }

  .disabled {
    a {
      color: ${COLORS.neutral_300};
    }
    svg {
      color: ${COLORS.neutral_300};
    }
    background-color: ${COLORS.neutral_100};
  }
`;

export const MenuLink = styled(NavLink)`
  border: none;
  background: transparent;
  margin: auto;

  box-sizing: border-box;

  font-style: normal;
  font-weight: normal;
  font-size: 19px;

  color: ${COLORS.black};
  text-decoration: none;
  text-align: center;
  align-items: center;
  display: flex;
`;

export const MenuWrapper = styled.div<MenuWrapperProps>`
  background-color: ${COLORS.white};
  display: ${props => (props.isVisible ? 'flex' : 'none')};
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;

  &:focus-within,
  &:hover,
  &.open {
    background: ${COLORS.white};
  }
`;

interface MenuWrapperProps {
  isVisible: boolean;
}

export const flowDown = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
